module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-card ",
    staticStyle: {
      "width": "auto",
      "min-width": "320px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.profile.change_password')))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.current_password'),
      "type": {
        'is-danger': _vm.data.messages.pass
      },
      "message": ( _obj = {}, _obj[_vm.$t(("index.profile.errors." + (this.data.messages.pass)))] = _vm.data.messages.pass, _obj )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.pass),
      callback: function($$v) {
        _vm.$set(_vm.form, "pass", $$v)
      },
      expression: "form.pass"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.new_password'),
      "type": {
        'is-danger': _vm.data.messages.newpass
      },
      "message": ( _obj$1 = {}, _obj$1[_vm.$t(("index.profile.errors." + (this.data.messages.newpass)))] = _vm.data.messages.newpass, _obj$1 )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.newpass),
      callback: function($$v) {
        _vm.$set(_vm.form, "newpass", $$v)
      },
      expression: "form.newpass"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.confirm_password'),
      "type": {
        'is-danger': _vm.data.messages.confirmpass
      },
      "message": ( _obj$2 = {}, _obj$2[_vm.$t(("index.profile.errors." + (this.data.messages.confirmpass)))] = _vm.data.messages.confirmpass, _obj$2 )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.confirmpass),
      callback: function($$v) {
        _vm.$set(_vm.form, "confirmpass", $$v)
      },
      expression: "form.confirmpass"
    }
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.close')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.$t('index.save')))])])])])
  var _obj;
  var _obj$1;
  var _obj$2;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-062c6ad6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/mini_components/Changepassword.vue
// module id = 296
// module chunks = 2